import React, { useState } from 'react';
import ChapterwiseMediaList from './ChapterwiseMediaList';
import { Image, Modal, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import VideoHlsPlayer from '../../../Student/Resources/VideoHlsPlayer';
import constants from '../../../../constants/constants';

const GetChapterVideos = () => {
	const [videoDetails, setvideoDetails] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const getVideoColumns = () => [
		{
			title: 'Chapter',
			dataIndex: 'chapter_id',
			key: 'chapter_id',
			align: 'center'
		},
		{
			title: 'Video #',
			dataIndex: 'resource_file_id',
			key: 'resource_file_id',
			align: 'center',
			render: (id) => `#${id}`
		},
		{
			title: 'Video',
			dataIndex: 'thumbnail_path',
			key: 'video_path',
			align: 'center',
			width: "10%",
			render: (path, record) => (
				<Image
					src={path}
					alt="img"
					className='cursor-pointer'
					onClick={() => handlePreviewVideo(record)}
					preview={false}
				/>
			)
		},
		{
			title: 'Caption',
			dataIndex: 'caption',
			key: 'caption',
			render: (caption, record) => (
				<Tooltip title={caption}>
					<Link className='linkColor' to={`/editVideo/${record.chapter_id}`} state={{ chapterId: record.chapter_id, entireRecord: record }}>
						{caption}
					</Link>
				</Tooltip>
			)
		},
		{
			title: 'Video Name',
			dataIndex: 'resource_name',
			key: 'resource_name'
		},
		{
			title: 'Category',
			dataIndex: 'category_name',
			key: 'category',
			align: 'center'
		},
		{
			title: <div className='text-base'>Duration</div>,
			dataIndex: "duration",
			key: "duration",
			width: '8%',
			render: (duration) => (
				<span className="text-sm">{duration}</span>
			),
			align: 'center'
		},
		{
			title: <div className='text-base'>File size</div>,
			dataIndex: "file_size",
			key: "file_size",
			width: '8%',
			render: (fileSize) => (
				<span className="text-sm">{fileSize}</span>
			),
			align: 'center'
		}
	];

	const handlePreviewVideo = (videoDetails) => {
		const nameWithoutExtension = videoDetails?.resource_name?.substring(0, videoDetails?.resource_name?.lastIndexOf("."));
		videoDetails.filename = nameWithoutExtension;
		setShowModal(true);
		setvideoDetails(videoDetails);
	};

	return (
		<>
			<ChapterwiseMediaList
				apiEndpoint="/get-videos"
				fetchPreview={null} // Not needed for video
				columns={getVideoColumns}
				onAddRoute="/add-video"
				pageTitle="Video"
				pageCrumb="video-list"
			/>
			<Modal
				open={showModal}
				onCancel={() => setShowModal(false)}
				footer={null}
				width="90%"
				centered
				title={
					<div className="w-full text-center text-lg font-bold md:text-lg">
						{videoDetails?.caption || "Video Preview"}
					</div>
				}
				bodyStyle={{
					padding: '1rem',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					flexDirection: 'column',
				}}
			>
				{videoDetails?.filename && (
					<div className="w-full">
						<VideoHlsPlayer
							videoDetails={videoDetails}
							apiUrl={`${constants.AdminApiUrl}/get-video-chunk-admin/0/0`}
						/>
					</div>
				)}
			</Modal>

		</>
	);
};

export default GetChapterVideos;